<template>
  <!--  <div ></div>-->
  <div v-if="!isConfigConnectAuthorizationPartner" class="app flex-row align-items-center" id="formLogin">
    <div style="width: 100%;height: 100vh;">
      <CRow class="justify-content-center"
            style="height: 100%;margin: auto 0!important;background: url('../static/img/background-design.png')">
        <CCol id="content-right" md="12" xl="4" style="margin:auto;">
          <div class="container">
            <CCard no-body style="background: rgba(71, 118, 223, 0.18);border: none!important;min-width: 400px;">
              <CCardBody>

                <CForm id="form-login">
                  <h2 style="text-align:center;margin-bottom: 30px;font-weight: bold; font-size: 1.65rem;"
                      class="form-fade-in-top">
                    Đăng nhập
                  </h2>
                  <div class="form-fade-in-bottom">
                    <div class="mb-2" style="margin-top: 15px!important;">
                      <BaseInput :listener="userNameInput.listener" :options="userNameInput.options"
                                 :data="userNameInput.data" class="input-wrapper"/>
                    </div>
                    <div class="mb-2" style="margin-top: 20px!important;">
                      <BaseInput :options="passWordInput.options" :listener="passWordInput.listener"
                                 :data="passWordInput.data" class="input-wrapper"/>
                    </div>
                    <template v-if="isVerifyRecaptcha == true">
                      <div class="mb-2" style="margin-top: 20px!important;" id="g-recaptcha"></div>
                      <div class="valid-error"
                           v-show="!(recaptchaInput.data.validator ? recaptchaInput.data.validator.isValid : true)">
                        {{ recaptchaInput.data.validator ? recaptchaInput.data.validator.errorMessage : "" }}
                      </div>
                    </template>
                    <CRow>
                      <CCol cols="12" style="margin-top: 15px!important;">
                        <button type="button" class="px-12 ripple btn-primary" @click="submitLogin()" id="login" style="padding: 8px!important; height: 42px!important;border-radius: 2.5rem!important;
                                background: linear-gradient(to right, #6e50ff, #506bff, #0093ff)!important;
                                font-size: 1rem!important;font-weight: 400!important;text-transform: uppercase;">
                          Đăng nhập&nbsp;
                          <div class="ripple-effect" hidden></div>
                        </button>
                      </CCol>
                    </CRow>
                  </div>
                  <div style="display: flex;justify-content: center;margin-bottom: 15px;"></div>
                </CForm>
              </CCardBody>
            </CCard>
          </div>
        </CCol>
      </CRow>
    </div>
    <BaseLoading :loading="loading.value"></BaseLoading>
  </div>
</template>
<script>
import BaseLoading from "../base/BaseFormLoading";
import BaseInput from "../base/BaseInput";

import {authLogin, authLoginBySSO} from "@/security/index";
import {
  CLIENT_ID,
  CLIENT_ID_NAME,
  CONFIG_AUTHORIZATION_CONNECT_PARTNER,
  IS_VERIFY_OTP_WITH_MAIL,
  IS_VERIFY_RECAPTCHA,
  TIME_OTP_EXPIRED,
  USER_NAME
} from "@/constant";

export default {
  name: "Login",
  components: {BaseInput, BaseLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  mounted: function () {
    if (!CONFIG_AUTHORIZATION_CONNECT_PARTNER) {
      let that = this;
      setTimeout(function () {
        that.setUpRippleButton();
      }, 500);
      this.checkTimeExpOTP();
      if (this.isVerifyRecaptcha == true) {
        this.initReCaptcha();
      }
    }
  },
  created: function () {
    if (CONFIG_AUTHORIZATION_CONNECT_PARTNER) {
      if (this.$route.query && this.$route.query.code) {
        this.getUserInfoByToken(this.$route.query.code);
      } else {
        window.location.href = this.ssoUrl;
      }
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      isConfigConnectAuthorizationPartner: CONFIG_AUTHORIZATION_CONNECT_PARTNER,
      isVerifyRecaptcha: IS_VERIFY_RECAPTCHA,
      status: true,
      ssoUrl: (this.$route.query && this.$route.query.isLogout == true) ? process.env.SSO_ADDRESS : `${process.env.SSO_ADDRESS}/login.html?redirect-uri=${encodeURIComponent(process.env.URI_REDIRECT)}&client-id=${CLIENT_ID}`,

      clientId: {
        data: {
          name: "client_id",
          model: this.$route.query['client-id'] || CLIENT_ID,
        }
      },
      userNameInput: {
        options: {
          placeholder: "Tài khoản",
          type: "text",
          autocomplete: "off"
        },
        data: {
          name: "username",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.userNameInput.data.model;
              let username_regex = /^([a-zA-Z0-9 !%&@#$^*?_~]){6,}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên đăng nhập không được để trống";
              } else if (username_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage =
                  "Tên đăng nhập ít nhất 6 kí tự và là chữ thường";
              } else if (username_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        },
        listener: {
          keyup: function (event) {
            if (event.key === "Enter") {
              that.submitLogin();
            }
          }
        }
      },
      passWordInput: {
        options: {
          placeholder: "Mật khẩu",
          type: "password",
          autocomplete: "off"
        },
        data: {
          name: "password",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.passWordInput.data.model;
              let password_regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,128}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mật khẩu không được để trống";
              } else if (password_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Mật khẩu sai định dạng";
              } else if (password_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        },
        listener: {
          keyup: function (event) {
            if (event.key === "Enter") {
              that.submitLogin();
            }
          }
        }
      },
      recaptchaInput: {
        data: {
          model: '',
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = grecaptcha.getResponse();
              if (value === "" || value.length < 0) {
                this.isValid = false;
                this.errorMessage = "Vui lòng xác thực captcha";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    initReCaptcha: function () {
      var self = this;
      setTimeout(function () {
        if (typeof grecaptcha === 'undefined') {
          self.initReCaptcha();
        } else {
          grecaptcha.render('g-recaptcha', {
            'sitekey': process.env.KEY_RECAPTCHA,
            'theme': 'light',
            'type': 'image',
            'data-size': 'compact',
            'expired-callback': function () {
              grecaptcha.reset();
            }
          })
        }
      }, 500);
    },
    interValCountdown() {
      this.otpInterVal = window.setInterval(() => {
        this.now = Math.trunc((new Date()).getTime());
      }, 1000);
    },
    checkTimeExpOTP() {
      let timeExp = localStorage.getItem(TIME_OTP_EXPIRED);
      if (timeExp && timeExp != undefined) {
        let dateExp = new Date(timeExp * 1);
        if (dateExp <= new Date()) {
          this.disableBtnVerifyOTP = true;
        }
      }
    },
    setUpRippleButton: function () {
      $(".ripple").on("click", function (event) {
        event.preventDefault();
        let $div = $("<div/>"),
          btnOffset = $(this).offset(),
          xPos = event.pageX - btnOffset.left,
          yPos = event.pageY - btnOffset.top;
        $div.addClass("ripple-effect");
        let $ripple = $(".ripple-effect");
        $div
          .css({
            top: yPos - $ripple.height() / 2,
            left: xPos - $ripple.width() / 2
          })
          .appendTo($(this));
        window.setTimeout(function () {
          $div.remove();
        }, 1500);
      });
    },
    submitLogin: function () {
      let that = this;
      let isValid = true;
      isValid &= this.userNameInput.data.validator.valid();
      isValid &= this.passWordInput.data.validator.valid();
      if (this.isVerifyRecaptcha == true) {
        isValid &= this.recaptchaInput.data.validator.valid();
      }
      if (!isValid) {
        return;
      }

      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/login",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            username: btoa(that.userNameInput.data.model),
            password: btoa(that.passWordInput.data.model),
            client_id: btoa(that.clientId.data.model),
          };
        },
        successCallback: function (response) {
          let {data} = response.data;
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(data)});
            // grecaptcha.reset();
          } else {
            if (IS_VERIFY_OTP_WITH_MAIL === true) {
              // let clientId = that.$route.query['client-id'];
              // let redirectURI = that.$route.query['redirect-uri'];
              localStorage.setItem(USER_NAME, data.userName);
              localStorage.setItem(TIME_OTP_EXPIRED, data.expireDate);
              localStorage.setItem(CLIENT_ID_NAME, data.clientId);
              // if (that.$route.query && clientId && redirectURI) {
              //   that.$router.push({
              //     path: '/verify.html', query: {'redirect-uri': redirectURI, 'client-id': clientId}
              //   });
              // } else {
              //   that.$router.push({path: '/verify.html'});
              // }
              that.$router.push({path: '/verify.html'});
              that.showSuccessMsg({message: "Mã xác thực OTP của đã được gửi về email. Vui lòng kiểm tra email và xác thực người dùng. Xin cảm ơn."})
            } else {
              authLogin(data.access_token, data.refresh_token, data.expires_in, data.authorities, data.username, data.fullName, data.id, JSON.stringify(data.systems), data.lastUpdatePassword);
            }
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    getUserInfoByToken: function (auth_code) {
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/oauth/user",
        //oauth code
        isRequestBearerToken: false,
        dataSubmit: function () {
          return {
            auth_code: auth_code
          }
        },
        successCallback: function (response) {
          if (response.status === 200) {
            let dataResponse = response.data;
            if (dataResponse.returnCode !== 1) {
              that.showErrorMsg({message: that.$helper.getStringError(dataResponse.data)});
            } else {
              //token
              // authLogin(dataResponse.data.accessToken, dataResponse.data.roles, dataResponse.data.username, dataResponse.data.userId, that.$route.query.exp);
              //oauth code
              authLoginBySSO(dataResponse.data.accessToken, dataResponse.data.roles, dataResponse.data.username, dataResponse.data.userId, dataResponse.data.expires, dataResponse.data.locationCode, dataResponse.data.fullName, dataResponse.data.userPosition);
            }
          } else {
            window.location.href = this.ssoUrl
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  }
};
</script>

<style>
#formLogin .input-wrapper > div > input {
  height: 42px !important;
}

#formLogin .loading-wrapper {
  background-color: rgba(2, 2, 2, 0.31);
}

.confirm-otp {
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 3px;
}
</style>
<style scoped>
.countdown {
  display: flex;
  justify-content: center;
}

.block {
  display: flex;
  flex-direction: column;
}

.digit {
  font-size: 30px;
  font-weight: 100;
  font-family: 'Roboto', serif;
  text-align: center;
  display: inline-flex;
  align-items: center;
}

.btn.btn-action-primary.btn-primary,
.btn.btn-action-primary.btn-primary:hover {
  border: none !important;
}

.group-button-special {
  margin-top: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.btn-special-google,
.btn-special-facebook {
  border: 1px solid #aaa;
  margin-right: 8px;
  width: 40%;
  font-size: 17px;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-special-google svg,
.btn-special-facebook svg {
  margin-right: 5px !important;
}

.btn-special-google:hover {
  border-color: #ff8500;
  color: #ff8500;
}

.btn-special-facebook:hover {
  border-color: #0064ff;
  color: #1d70ff;
}

#register {
  margin-top: 15px;
  text-align: center;
}

#login:hover {
  background: rgba(13, 175, 223, 1) !important;
}

.mb-3 {
  margin-bottom: 0px !important;
  margin-top: 10px !important;
}

fieldset {
  border: 1px solid #ccc;
  padding: 15px;
  max-width: 345px;
  background-color: #fff;
  border-radius: 5px;
}

section {
  padding: 0 15px;
}

@media (max-width: 350px) {

  .btn-special-google[data-v-07b13bd8],
  .btn-special-facebook[data-v-07b13bd8] {
    width: unset !important;
  }

  .container {
    padding: 0px !important;
  }

  #content-left {
    width: 0;
    height: 0;
  }

  #forget {
    width: 50% !important;
  }
}

@media (min-width: 350px) and (max-width: 575px) {
  .container {
    padding: 0px !important;
  }

  #content-left {
    width: 0;
    height: 0;
  }
}

@media (min-width: 576px) and (max-width: 665px) {

  .btn-special-google[data-v-07b13bd8],
  .btn-special-facebook[data-v-07b13bd8] {
    font-size: 13px;
  }

  .container {
    padding: 0px !important;
  }

  #content-left {
    width: 0;
    height: 0;
  }

  #content-right {
    padding-left: 0px;
    padding-right: 0;
  }
}

@media (min-width: 666px) and (max-width: 767px) {

  .btn-special-google[data-v-07b13bd8],
  .btn-special-facebook[data-v-07b13bd8] {
    font-size: 13px;
  }

  .container {
    padding: 0px !important;
  }

  #content-left {
    width: 0;
    height: 0;
  }

  #content-right {
    padding-left: 0px;
    padding-right: 0;
  }
}

@media (min-width: 768px) and (max-width: 1100px) {

  .btn-special-google[data-v-07b13bd8],
  .btn-special-facebook[data-v-07b13bd8] {
    font-size: 13px;
  }
}

@media (min-width: 1101px) and (max-width: 1225px) {

  .btn-special-google[data-v-07b13bd8],
  .btn-special-facebook[data-v-07b13bd8] {
    font-size: 16px;
  }
}
</style>
